import React from 'react'
import Layout from '../Layout'
import { useRoutes } from '../../hooks/useRoutes'

const PeractoRoute = ({ location: { pathname } }) => {
    const routes = useRoutes()

    return <>{pathname.includes('/content/edit') ? <>{routes}</> : <Layout routes={routes} />}</>
}

export default PeractoRoute
